import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useProductRefreshSettingsIa } from 'features/app_shell/product_refresh/useProductRefreshSettingsIa';
const formContainerIsTabletUpCss = "fggsmhw";
const formContainerCss = "fsegmsl";
export const FormContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isTabletUp = useDeviceType('isTabletUp');
  const isRebrandSettingsIaEnabled = useProductRefreshSettingsIa();
  return <Component ref={ref} {...restProps} className={classNames(formContainerCss, {
    [formContainerIsTabletUpCss]: isTabletUp && !isRebrandSettingsIaEnabled
  }, props.className)} />;
});
const formRowCss = "f1jii6w";
export const FormRow = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(formRowCss, props.className)} />;
});
const noMarginTopCss = "n1pyo431";
const formButtonsIsTabletUpCss = "f69pidg";
const formButtonsCss = "f19l9275";
export const FormButtons = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    noMarginTop,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isTabletUp = useDeviceType('isTabletUp');
  return <Component ref={ref} {...restProps} className={classNames(formButtonsCss, {
    [formButtonsIsTabletUpCss]: isTabletUp,
    [noMarginTopCss]: noMarginTop
  }, props.className)} />;
});
const styledFormRowCss = "s1spmaxh";
export const StyledFormRow = forwardRef((props, ref) => <FormRow ref={ref} {...props} className={classNames(styledFormRowCss, props.className)} />);
const titleContentWrapperCss = "t15letbx";
export const TitleContentWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(titleContentWrapperCss, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");